// @flow
import React from 'react';

import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { mb, px, pb } from 'styled-components-spacing';

import { fontLight } from '@styles/typography';
import theme from '@theme';

const { colors } = theme;

export const StyledHeadlineText = styled(
  React.forwardRef((props, ref) =>
    (props.component ? <props.component ref={ref} {...props} /> : <p ref={ref} {...props} />))
)`
  font-size: 24px;
  font-weight: 500;
  line-height: 1.44;
  ${pb(3)}
  z-index: 10;
  position: relative;
`;

export const StyledHeadlineTextSection = styled(
  React.forwardRef((props, ref) =>
    (props.component ? <props.component ref={ref} {...props} /> : <p ref={ref} {...props} />))
)`
  ${fontLight}
  font-size: 18px;
  text-align: center;
  text-transform: uppercase;
  ${mb(3)}
  z-index: 10;
  position: relative;

  ${breakpoint('desktop')`
    font-size: 20px;
  `}
  
  ${breakpoint('mobile', 'tablet')`
    font-size: 14px;
    line-height: 17px;
    font-weight: 400;
  `}
  
`;

export const StyledHeadlineTextSectionLeft = styled(StyledHeadlineTextSection)`
  text-align: left;
  z-index: 10;
  position: relative;
`;

export const StyledHeadlineTextSectionBright = styled(StyledHeadlineTextSection)`
  color: ${colors.white};
`;

export const StyledSubHeadlineSection = styled(
  React.forwardRef((props, ref) =>
    (props.component ? <props.component ref={ref} {...props} /> : <h2 ref={ref} {...props} />))
)`
  font-size: 32px;
  line-height: 1.4;
  margin: 0 auto;
  max-width: 720px;
  text-align: center;
  ${mb(4)}
  ${px(4)}

  ${theme.typography.Raleway}

  z-index: 10;
  position: relative;

  ${breakpoint('desktop')`
    font-size: 40px;
    
    ${px(0)}
  `}

  ${breakpoint('mobile', 'tablet')`
    font-size: 18px;
    line-height: 22px;
    font-weight: 500;
    ${px(0)}
  `}
`;

export const StyledSubHeadlineSectionBright = styled(StyledSubHeadlineSection)`
  color: ${colors.white};

  z-index: 10;

  position: relative;
`;
